// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + {"184":"misc1","325":"form","886":"commerce"}[chunkId] + "." + {"184":"313487c5","325":"d1999272","886":"df3faa2b"}[chunkId] + ".bundle.js";
};